const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const UPDATE_CART = 'UPDATE_CART';
const PARTNER_AVL = 'PARTNER_AVL';
const PUSH_MESSAGE_CALL = 'PUSH_MESSAGE_CALL';
const UPDATE_CART_FAIL = 'UPDATE_CART_FAIL';
const UPDATE_CART_FAIL_RESPONSE = 'UPDATE_CART_FAIL_RESPONSE';
const DAW_COUPON = 'DAW_COUPON';
const UPDATE_CART_API = 'UPDATE_CART_API';

export {
  GET_DATA_FROM_API,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_DATA_SUCCESS,
  ERR_OCCURED,
  UPDATE_CART,
  PARTNER_AVL,
  PUSH_MESSAGE_CALL,
  UPDATE_CART_FAIL,
  UPDATE_CART_FAIL_RESPONSE,
  DAW_COUPON,
  UPDATE_CART_API,
};
